(function() {
  function formatMoney(amount, currency) {
    if (typeof amount !== 'number' || isNaN(amount)) return '';
    var code = currency || (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'MXN';
    try {
      return new Intl.NumberFormat(undefined, { style: 'currency', currency: code }).format(amount / 100);
    } catch (e) {
      return '$' + (amount / 100).toFixed(2);
    }
  }

  function getCurrencyCode() {
    var code = document.documentElement.getAttribute('data-currency');
    if (code) return code;
    if (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) {
      return window.Shopify.currency.active;
    }
    return 'MXN';
  }

  function updateLineUI(line) {
    var key = line.key || line.id;
    if (!key) return;

    var rowEl = document.querySelector('tr[data-key="' + key + '"]') ||
                document.querySelector('tr#CartItem-' + key);
    if (!rowEl) return;

    var currency = getCurrencyCode();

    var unitPriceEl = rowEl.querySelector('.cart-items__unit-price-wrapper span');
    var lineTotalEl = rowEl.querySelector('.cart-items__price text-component');
    var originalPriceEl = rowEl.querySelector('.cart-items__price s.compare-at-price');

    if (typeof line.price === 'number' && unitPriceEl) {
      unitPriceEl.textContent = formatMoney(line.price, currency);
    }
    if (typeof line.line_price === 'number' && lineTotalEl) {
      lineTotalEl.textContent = formatMoney(line.line_price, currency);
      lineTotalEl.setAttribute('value', formatMoney(line.line_price, currency));
    }
    if (typeof line.original_price === 'number' && originalPriceEl) {
      if (line.original_price !== line.price) {
        originalPriceEl.textContent = formatMoney(line.original_price, currency);
        originalPriceEl.style.display = '';
      } else {
        originalPriceEl.style.display = 'none';
      }
    }
  }

  function updateCartUIFromCart(cart) {
    if (!cart) return;
    if (Array.isArray(cart.items)) {
      cart.items.forEach(updateLineUI);
    }
  }

  function fetchCart() {
    return fetch('/cart.js')
      .then(function(response) { return response.json(); })
      .catch(function() { return null; });
  }

  var observer = null;
  function startObserver() {
    if (observer) { try { observer.disconnect(); } catch(e) {} observer = null; }
    observer = new MutationObserver(function() {
      if (window.__bundlerCartRerenderTimer) clearTimeout(window.__bundlerCartRerenderTimer);
      window.__bundlerCartRerenderTimer = setTimeout(function() {
        fetchCart().then(updateCartUIFromCart);
      }, 200);
    });
    try {
      observer.observe(document.body, { childList: true, subtree: true });
    } catch(e) {}
  }

  function initBundlerCartUI() {
    if (window.__bundlerCartUIInited) return;
    window.__bundlerCartUIInited = true;

    fetchCart().then(updateCartUIFromCart);

    try {
      if (window.Bundler && typeof window.Bundler.on === 'function') {
        window.Bundler.on('cart:updated', function() {
          fetchCart().then(updateCartUIFromCart);
        });
      } else if (window.Bundler && typeof window.Bundler.subscribe === 'function') {
        window.Bundler.subscribe('cart:updated', function() {
          fetchCart().then(updateCartUIFromCart);
        });
      }
    } catch(e) {}

    startObserver();

    window.addEventListener('shopify:section:load', function() {
      fetchCart().then(updateCartUIFromCart);
    });
  }

  document.addEventListener('DOMContentLoaded', initBundlerCartUI);
  document.addEventListener('shopify:section:load', initBundlerCartUI);
})();
